export const lotInputParams = {
    label: '分公司',
    prop: 'companyName',
    width: 150,
    name: '分公司',
    value: 'companyName',
    type: 'advance',
    // maxNum: 10, // 多选条数限制
    isFixed: true,
    span: 4,
    advanceConfig: [
        { 'prop': 'companyNameCn', 'value': '分公司名称' },
        { 'prop': 'companyCode', 'value': '分公司编码' }
    ],
    tableConfig: [
        { 'prop': 'companyCode', 'value': '分公司编码' },
        { 'prop': 'companyNameCn', 'value': '分公司名称', 'displayName': 'companyNameCn' }
    ],
    prefix: '/api-mdm',
    advanceUrl: `/esCompany/popCompany`,
    cbParams: ['companyCode', 'companyNameCn#companyName']
};
